import { SHIFT_DISCOVERY_ENABLE_LOCATION_PERMISSIONS_PATH } from "../../ShiftDiscovery/paths";
import { type NavigateToModalFunction } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { useCheckPreBookingState } from "../Booking/useCheckPreBookingState";

interface UseBidActionProps {
  shiftId: string | undefined;
  workplaceId?: string;
  navigateToModal: NavigateToModalFunction;
  onCanProceed: () => void;
}

export function useBidAction(props: UseBidActionProps) {
  const { shiftId, workplaceId, navigateToModal, onCanProceed } = props;

  const { geolocationIsUnavailable, isPreBookingChecksLoading } = useCheckPreBookingState({
    workplaceId,
    shiftId: shiftId ?? "",
  });

  const attemptBidAction = () => {
    if (geolocationIsUnavailable) {
      navigateToModal(SHIFT_DISCOVERY_ENABLE_LOCATION_PERMISSIONS_PATH);
      return;
    }

    onCanProceed();
  };

  return {
    attemptBidAction,
    isLoading: isPreBookingChecksLoading,
  };
}
